export default __webpack_public_path__ + "static/pragicts-ai-agriculture-22c9ea4b824bdcbc176a02e1e06436e4.jpg";